import fetch from 'auth/FetchInterceptor'

const AuthService = {}

AuthService.login = function (data) {
	return fetch({ url: '/auth/login', method: 'post', data })
}

AuthService.register = function (data) {
	return fetch({ url: '/auth/register', method: 'post', data })
}

AuthService.refresh = function (refresh) {
	return fetch({ url: '/auth/refresh', method: 'post', data: { refresh } })
}

AuthService.me = function () {
	return fetch({ url: '/auth/me', method: 'get' })
}

AuthService.updateProfile = function (data) {
	return fetch({ url: '/auth/me', method: 'patch', data })
}

AuthService.changePassword = function (data) {
	return fetch({ url: '/auth/change-password', method: 'post', data })
}

AuthService.requestPasswordReset = function (email) {
	return fetch({ url: '/auth/password-reset/request', method: 'post', data: { email } })
}

AuthService.confirmPasswordReset = function (data) {
	return fetch({ url: '/auth/password-reset/confirm', method: 'post', data })
}

export default AuthService
